export const REGISTRATION_TYPES = [
  'unplannedAttendance',
  'plannedAttendance',
  'unplannedAbsence',
  'plannedAbsence',
];

export const WORK_TIME_TYPES = ['work', 'absence', 'pause'];

export const REGISTRATION_CATEGORIES = [
  'normal_hours', 'break', 'overtime_voluntary', 'overtime_forced',
  'overtime_holiday', 'unscheduled_workday', 'forskudttid',
  'sick_leave_start_reg', 'sick_leave_child', 'sick_leave_pregnancy',
  'sick_leave_work_injury', 'sick_leave_chronic',
  'care_leave', 'compassionate_leave', 'compassionate_leave_critical',
  'child_hospital', 'child_care_day', 'grandchild_care_day', 'salary_reduction',
  'education', 'course',
  'vacation', 'extra_vacation', 'afspadsering', 'fritvalg',
  'public_holiday', 'special_day', 'senior_day',
  'parental_leave_birth', 'parental_leave_non_birth', 'parental_leave_shared',
];

export const STATISTICAL_CATEGORIES = ['attendance', 'sickleave', 'personal', 'vacation', 'leave'];

export const ACCOUNT_HANDLINGS = [
  'timeOff_in_normal', 'timeOff_in_voluntary', 'timeOff_in_forced',
  'timeOff_out', 'vacation_out', 'extraVacation_out',
  'sickLeaveFull_in', 'sickLeave_in', 'fritvalg_out',
  'salaryReduction_out', 'none',
];

export const TIME_OFF_TYPES = [
  'none', 'workTime', 'breakTime', 'timeOff', 'sickLeave',
  'overtimeVoluntary', 'overtimeForced', 'unscheduledWorkdayForced',
];

export const LEAVE_TYPES = ['none', 'fullLeave', 'parentalLeave'];

export const OBSCURED_CATEGORIES = ['sickObscured', 'offWorkObscured', 'awayObscured'];

export const PERIOD_TYPES = ['calendarYear', 'ferieYear', 'rolling12Months', 'perBirthEvent'];

export const FUNDING_SOURCES = ['employer', 'fritvalg', 'pension', 'unpaid'];
